/* eslint-disable camelcase */
// third-party
import { createSlice } from '@reduxjs/toolkit';
import { filterQueryString } from 'helpers/objectFunctions';
import { devConsolelog } from 'helpers/utilityFunctions';

// project imports
import { ARYABHATTA_API_DOMAIN_V1 } from 'config';
import { dispatch } from 'store';
import axios from 'utils/axios';
import { DEFAULT_ERROR_MESSAGE } from '../constant';
import { openSnackbar } from './snackbar';

const initialState = {
    error: null,
    data: {},
    myQuotesData: {},
    selectedObjectData: {},
    isLoading: false,
    filters: {},
    filterOptions: {
        category: {}
    },
    preservedRequirementFollowupData: {
        current_status: '',
        remarks: '',
        next_follow_up_on: null,
        potential: null,
        flights_booked: null
    },
    currentTabValue: 0,
    searchFilter: ''
};

const slice = createSlice({
    name: 'requirementFunnel',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // setData
        setReqCountData(state, action) {
            devConsolelog(`countdata in object`, action.payload);
            state.data.reqCountData = action.payload;
        },

        setCurrentTab(state, action) {
            devConsolelog(`countdata in object`, action.payload);
            state.currentTabValue = action.payload;
        },

        // setData
        setData(state, action) {
            const { count = 0, next = null, status, results = {}, page = 0 } = action.payload;
            const { utilities = {}, requirement_list: requirementFunnelList = [] } = results || {};

            devConsolelog(`status in object`, status);
            state.data.count = count;
            state.data.status = status;
            state.data.next = next;
            state.data.utilities = utilities;
            state.data.requirementFunnelList = requirementFunnelList;
            state.data.currentPage = page;
        },

        // append data from previous state in current state
        appendListData(state, action) {
            const { count = 0, next = null, status, results = {}, page = 0 } = action.payload;
            const { utilities = {}, requirement_list: requirementFunnelList = [] } = results || {};
            state.data.count = count;
            state.data.status = status;
            state.data.next = next;
            state.data.utilities = utilities;
            state.data.currentPage = page;

            state.data.requirementFunnelList = state.data.requirementFunnelList.concat([...requirementFunnelList]);
        },

        setFilters(state, action) {
            // payload has filter object (destination, date range, etc.)
            devConsolelog('data in state filters', action.payload, state.filters);
            state.filters = action.payload;
        },

        setSearchFilter(state, action) {
            // payload has filter object (destination, date range, etc.)
            devConsolelog('data in state filters', action.payload, state.filters);
            state.searchFilter = action.payload;
            // state.data.currentPage = 0;
        },

        setIsLoading(state, action) {
            const { loadingField = '', isLoading = false } = action.payload || {};
            state[loadingField] = isLoading;
        },

        setInquiryHistoryData(state, action) {
            state.inquiryHistory = action.payload;
        },

        setOtherRequirementsData(state, action) {
            state.otherOpenRequirements = action.payload;
        },

        setOpenRequirementsData(state, action) {
            state.openRequirementsData = action.payload || {};
        },

        setMyQuotesData(state, action) {
            const { count = 0, next = null, previous = null, page = 0, results = [] } = action.payload || {};

            state.myQuotesData.count = count;
            state.myQuotesData.next = next;
            state.myQuotesData.previous = previous;
            state.myQuotesData.results = results;
            state.myQuotesData.currentPage = page;
        },

        setSelectedObjectData(state, action) {
            state.selectedObjectData = action.payload;
        },

        setDynamicRequirementObj(state, action) {
            const { results = {} } = action.payload;
            const { data = {} } = results || {};
            state.selectedObjectData = data;
        },

        setCategoriesData(state, action) {
            state.filterOptions.category = action.payload;
        },

        setDestinationExpertData(state, action) {
            state.filterOptions.destinationExpert = action.payload;
        },

        setStatsData(state, action) {
            state.statsSummary = action.payload || {};
        },

        setDestinationData(state, action) {
            state.filterOptions.destination = action.payload;
        },

        setBookingSummary(state, action) {
            state.bookingSummary = action.payload || {};
        },

        setMemberData(state, action) {
            state.memberData = action.payload || {};
        },

        setMemberRequirementEditableData(state, action) {
            state.editableRequirementData = action.payload || {};
        },

        setPreservedRequirementFollowupData(state, action) {
            const {
                current_status = '',
                remarks = '',
                next_follow_up_on = null,
                flights_booked = null,
                potential = null
            } = action.payload || {};
            state.preservedRequirementFollowupData.current_status = current_status;
            state.preservedRequirementFollowupData.remarks = remarks;
            state.preservedRequirementFollowupData.next_follow_up_on = next_follow_up_on;
            state.preservedRequirementFollowupData.potential = potential;
            state.preservedRequirementFollowupData.flights_booked = flights_booked;
        }
    }
});

// Reducer
export default slice.reducer;

export function getRequirementFunnelData(filterType = '', status = '1', pageChangeUrl = '', newPage = 0, searchVal = '') {
    if (!pageChangeUrl) {
        dispatch(slice.actions.setIsLoading({ loadingField: 'isRequirementLoading', isLoading: true }));
    }
    return async () => {
        devConsolelog('getRequirementFunnelData url from params', searchVal);
        let url = `${ARYABHATTA_API_DOMAIN_V1}acm/members/potential-leads/${status}/?`;
        if (pageChangeUrl) {
            url = `${pageChangeUrl}&`;
        }

        if (filterType) {
            const finalFilterQueryString = filterQueryString(filterType);
            url = `${url}${finalFilterQueryString}`;
        }
        if (searchVal && searchVal.length > 0) {
            url = `${url}&search=${searchVal}`;
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            if (!newPage) {
                dispatch(slice.actions.setData({ ...response.data, status, page: newPage || 0 }));
            } else {
                dispatch(slice.actions.appendListData({ ...response.data, status, page: newPage || 0 }));
            }
            if (!pageChangeUrl) {
                dispatch(slice.actions.setIsLoading({ loadingField: 'isRequirementLoading', isLoading: false }));
            }
        } catch (error) {
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            if (!pageChangeUrl) {
                dispatch(slice.actions.setIsLoading({ loadingField: 'isRequirementLoading', isLoading: false }));
            }
        }
    };
}

export function getRequirementCountData(filterType = '') {
    return async () => {
        let url = `${ARYABHATTA_API_DOMAIN_V1}acm/members/potential-leads/?`;
        if (filterType) {
            const finalFilterQueryString = filterQueryString(filterType);
            url = `${url}${finalFilterQueryString}`;
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setReqCountData(response.data));
        } catch (error) {
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getOpenRequirementsData(pageChangeUrl = '', memberCode = '', newPage = 0) {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isOpenRequirementLoading', isLoading: true }));
    return async () => {
        let url = `${ARYABHATTA_API_DOMAIN_V1}lms/requirements/?member_code=${memberCode}&page_size=10&type=open`;
        if (pageChangeUrl) {
            url = `${pageChangeUrl}&member_code=${memberCode}&page_size=10&type=open`;
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setOpenRequirementsData({ ...response.data, currentPage: newPage || 0 }));
            dispatch(slice.actions.setIsLoading({ loadingField: 'isOpenRequirementLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );

            dispatch(slice.actions.setIsLoading({ loadingField: 'isOpenRequirementLoading', isLoading: false }));
        }
    };
}

export function patchOtherOpenRequirements(memberCode, updatedRequirementData) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}lms/requirements/?member_code=${memberCode}&page_size=10&type=open`;
        try {
            const response = await axios.patch(url, updatedRequirementData, {
                headers: {
                    source: 'mweb'
                }
            });
            devConsolelog('response editTicketData', response.data);
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.setMemberRequirementEditableData({}));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function patchCurrentRequirementData(updatedRequirementData, reqCode) {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}lms/requirements/`;
        try {
            await axios.patch(url, updatedRequirementData, {
                headers: {
                    source: 'mweb'
                }
            });
            await dispatch(
                openSnackbar({
                    open: true,
                    message: `Requirement ${reqCode} Updated`,
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.hasError(''));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getSelectedObject(selectedObject) {
    return () => {
        dispatch(slice.actions.setSelectedObjectData({ ...selectedObject }));
    };
}

export function getInquiryHistoryData(reqCode = '', isDirectLink = false) {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isInquiryHistoryLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/members/requirements/${reqCode}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            if (isDirectLink) {
                dispatch(slice.actions.setDynamicRequirementObj({ ...response.data }));
            }
            dispatch(slice.actions.setInquiryHistoryData(response.data));
            dispatch(slice.actions.setIsLoading({ loadingField: 'isInquiryHistoryLoading', isLoading: false }));
        } catch (error) {
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'isInquiryHistoryLoading', isLoading: false }));
        }
    };
}

export function getCategoriesData() {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}travsys/categories`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            devConsolelog('response getCategoriesData', response.data);
            dispatch(slice.actions.setCategoriesData({ ...response.data }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {} } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getDestinationExpertData() {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}users/travclan-admin`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            devConsolelog('response getDestinationExpertData', response.data);
            dispatch(slice.actions.setDestinationExpertData({ ...response.data }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {} } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
        }
    };
}

export function getMemberStatsData(memCode = '', filterType = '', isBookingSummary = false) {
    if (isBookingSummary) {
        dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingSummaryLoading', isLoading: true }));
    } else {
        dispatch(slice.actions.setIsLoading({ loadingField: 'isMemberStatsLoading', isLoading: true }));
    }
    return async () => {
        let url = `${ARYABHATTA_API_DOMAIN_V1}members/${memCode}/stats`;
        if (filterType) {
            const finalFilterQueryString = filterQueryString(filterType);
            url = `${url}?${finalFilterQueryString}`;
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            if (isBookingSummary) {
                dispatch(slice.actions.setBookingSummary(response.data));
                dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingSummaryLoading', isLoading: false }));
            } else {
                dispatch(slice.actions.setStatsData(response.data));
                dispatch(slice.actions.setIsLoading({ loadingField: 'isMemberStatsLoading', isLoading: false }));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            if (isBookingSummary) {
                dispatch(slice.actions.setIsLoading({ loadingField: 'isBookingSummaryLoading', isLoading: false }));
            } else {
                dispatch(slice.actions.setIsLoading({ loadingField: 'isMemberStatsLoading', isLoading: false }));
            }
        }
    };
}

export function getMyQuotesData(reqCode = '', pageChangeUrl = '', newPage = 0) {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isQuoteLoading', isLoading: true }));
    return async () => {
        let url = `${ARYABHATTA_API_DOMAIN_V1}acm/requirements/${reqCode}/quotes`;
        if (pageChangeUrl) {
            url = pageChangeUrl;
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setMyQuotesData({ ...response.data, page: newPage || 0 }));
            dispatch(slice.actions.setIsLoading({ loadingField: 'isQuoteLoading', isLoading: false }));
        } catch (error) {
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'isQuoteLoading', isLoading: false }));
        }
    };
}

export function getMemberData(memCode = '') {
    dispatch(slice.actions.setIsLoading({ loadingField: 'isMemberDataLoading', isLoading: true }));
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}acm/members/${memCode}`;
        try {
            const response = await axios.get(url, {
                headers: {
                    // Authorization: authHardcodedToken,
                    source: 'mweb'
                }
            });
            dispatch(slice.actions.setMemberData(response.data));
            dispatch(slice.actions.setIsLoading({ loadingField: 'isMemberDataLoading', isLoading: false }));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
            const { error: errorObj = {}, detail = '' } = error || {};
            const { errorMessage = '' } = errorObj || {};
            dispatch(
                openSnackbar({
                    open: true,
                    message: errorMessage || detail || DEFAULT_ERROR_MESSAGE,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: false
                })
            );
            dispatch(slice.actions.setIsLoading({ loadingField: 'isMemberDataLoading', isLoading: false }));
        }
    };
}

export function getDestinationData() {
    return async () => {
        const url = `${ARYABHATTA_API_DOMAIN_V1}travsys/destinations`;
        try {
            const response = await axios.get(url, {
                headers: {
                    source: 'mweb'
                }
            });
            devConsolelog('response getDestinationData', response.data);
            dispatch(slice.actions.setDestinationData(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export const getPreservedRequirementFollowupData =
    (data = {}) =>
    () => {
        dispatch(slice.actions.setPreservedRequirementFollowupData(data));
    };

export const getMemberRequirementEditableData =
    (data = {}) =>
    () => {
        dispatch(slice.actions.setMemberRequirementEditableData(data));
    };

export const filterRequirementData =
    (filter = '') =>
    async () => {
        dispatch(slice.actions.setFilters(filter || initialState.filters));
    };

export const handleCurrentTabValue =
    (tabValue = 0) =>
    async () => {
        devConsolelog('in tab value', tabValue);
        dispatch(slice.actions.setCurrentTab(tabValue || initialState.currentTabValue));
    };

export const searchRequirementData =
    (search = '') =>
    async () => {
        dispatch(slice.actions.setSearchFilter(search || initialState.searchFilter));
    };

export const setLoadingState =
    (isLoading = false) =>
    async () => {
        dispatch(slice.actions.setIsLoading(isLoading));
    };
